<script>
  import { _ } from "svelte-i18n";
  export let pulse = "";
  export let ill = false;
  export let injured = false;
  export let menstrualCycle = false;
  export let travelDay = false;
  export let height = false;
  export let dayOff = false;
  export let competitionDay = false;
  export let gender;
</script>

<div
  class="health-status-checkbox-group health-status-checkbox-group--status {gender ===
  'female'
    ? 'health-status-checkbox-group--four-cols'
    : ''}"
>
  <label
    class="health-status-checkbox health-status-checkbox--status-ill"
    for="status-ill"
  >
    <input
      bind:checked={ill}
      type="checkbox"
      class="health-status-checkbox__input-hidden"
      name="status"
      title="Syk"
      id="status-ill"
      value="status-ill"
    />
    <span
      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-ill"
    />
    <span class="health-status-checkbox__label"
      >{$_("dayParameters.form.status.sick")}</span
    >
  </label>

  <label
    class="health-status-checkbox health-status-checkbox--status-injured"
    for="status-injured"
  >
    <input
      bind:checked={injured}
      type="checkbox"
      class="health-status-checkbox__input-hidden"
      name="status"
      title="Skadet"
      id="status-injured"
      value="status-injured"
    />
    <span
      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-injured"
    />
    <span class="health-status-checkbox__label"
      >{$_("dayParameters.form.status.injured")}</span
    >
  </label>

  {#if gender === "female"}
    <label
      class="health-status-checkbox health-status-checkbox--status-menstrualCycle"
      for="status-menstrualCycle"
    >
      <input
        bind:checked={menstrualCycle}
        type="checkbox"
        class="health-status-checkbox__input-hidden"
        name="status"
        title="Mensen"
        id="status-menstrualCycle"
        value="status-menstrualCycle"
      />
      <span
        class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-menstrualCycle"
      />
      <span class="health-status-checkbox__label"
        >{$_("dayParameters.form.status.menstruation")}</span
      >
    </label>
  {/if}

  <label
    class="health-status-checkbox health-status-checkbox--status-travelDay"
    for="status-travelDay"
  >
    <input
      bind:checked={travelDay}
      type="checkbox"
      class="health-status-checkbox__input-hidden"
      name="status"
      title="På reise"
      id="status-travelDay"
      value="status-travelDay"
    />
    <span
      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-travelDay"
    />
    <span class="health-status-checkbox__label">{$_("dayParameters.form.status.traveling")}</span>
  </label>

  <label
    class="health-status-checkbox health-status-checkbox--status-height"
    for="status-height"
  >
    <input
      bind:checked={height}
      type="checkbox"
      class="health-status-checkbox__input-hidden"
      name="status"
      title="Høydedøgn"
      id="status-height"
      value="status-height"
    />
    <span
      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-height"
    />
    <span class="health-status-checkbox__label">{$_("dayParameters.form.status.altitudeTraining")}</span>
  </label>

  <label
    class="health-status-checkbox health-status-checkbox--status-dayOff"
    for="status-dayOff"
  >
    <input
      bind:checked={dayOff}
      type="checkbox"
      class="health-status-checkbox__input-hidden"
      name="status"
      title="Fridag"
      id="status-dayOff"
      value="status-dayOff"
    />
    <span
      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-dayOff"
    />
    <span class="health-status-checkbox__label">{$_("dayParameters.form.status.dayOff")}</span>
  </label>

  <label
    class="health-status-checkbox health-status-checkbox--status-competitionDay"
    for="status-competitionDay"
  >
    <input
      bind:checked={competitionDay}
      type="checkbox"
      class="health-status-checkbox__input-hidden"
      name="status"
      title="Konkurranse"
      id="status-competitionDay"
      value="status-competitionDay"
    />
    <span
      class="health-status-checkbox__input-custom health-status-checkbox__input-custom--status-competitionDay"
    />
    <span class="health-status-checkbox__label">{$_("dayParameters.form.status.competition")}</span>
  </label>
</div>
<br />
<label for=""
  ><span class="input__label">{$_("dayParameters.form.pulse")}</span><span class="input__item"
    ><input
      type="numeric"
      class="input__number"
      data-label=""
      data-id=""
      name="Hvilepuls"
      id="Hvilepuls"
      autocomplete="off"
      bind:value={pulse}
    />
    <p class="input__error" />
  </span>
</label>
